import {isEmpty} from "../components/helpers/helpers";
import {getAvatar} from "../models/user";

export const crispConfig = (userContext, showCrisp = false) => {

    if (process.browser && showCrisp) {

        window.$crisp = [];
        window.CRISP_WEBSITE_ID = "7c3395bf-56ef-42bc-9d94-5b5571fec316";

        (function () {
            const d = document;
            const s = d.createElement("script");

            s.src = "https://client.crisp.chat/l.js";
            s.async = 1;
            d.getElementsByTagName("head")[0].appendChild(s);
        })();

        $crisp.push(["set", "session:data", ["validUser", true]]);
        $crisp.push(["do", "chat:hide"]);

        let userName = 'کاربر ناشناس';

        if (userContext && userContext.check) {
            if (!isEmpty(userContext.getName)) {
                userName = userContext.getName;
            } else {
                userName = (userContext.isRealtor || userContext.isAgency) ? 'مشاور ناشناس' : 'کاربر ناشناس'
            }
        }

        window.CRISP_READY_TRIGGER = function () {
            if ($crisp.get("session:data", "validUser") === true) {
                $crisp.push(["do", "chat:show"]);
                $crisp.push(["do", "chat:close"]);
                $crisp.push(["set", "user:nickname", userName]);

                if (userContext && userContext.check) {
                    const {user} = userContext;

                    if (!isEmpty(user.mobile)) {
                        $crisp.push(["set", "user:phone", user.mobile]);
                    }

                    if (!isEmpty(user.email)) {
                        $crisp.push(["set", "user:email", user.email]);
                    }

                    const avatar = !isEmpty(user.avatar) ? getAvatar(user.id) : getAvatar();

                    $crisp.push(["set", "user:avatar", [avatar]]);
                }
            }
        }
    }
}